import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'sibat-link-button',
  template: `
    <a class="button-link" [href]="href" [target]="target">
      <span>{{ label }}</span>
      @if (external) {
      <mat-icon style="font-size: smaller">open_in_new</mat-icon>
      }
    </a>
  `,
  styleUrls: ['buttons.scss'],
  imports: [MatIcon],
})
export class LinkButtonComponent {
  @Input() label: string;
  @Input() href: string;
  @Input() external: boolean;
  @Input() target = '_self';

  constructor() {}
}
